import { Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { SnackBar } from 'src/components/SnackBar';
import Calander from './Calander';
import Event from './Event';
import './YearPlan.css';
import UploadIcon from '@mui/icons-material/Upload';
import GetAppIcon from '@mui/icons-material/GetApp';
import { addCompanyLeaveBulk } from 'src/services/yearPlannerService';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import StarIcon from '@mui/icons-material/Star';
import NavigationIcon from '@mui/icons-material/Navigation';

const YearPlan = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();
  const [isGetDataChild, setIsGetDataChild] = useState<Boolean>(false);
  const [clearFilePath, setClearFilePath] = useState<string>('');

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const allowedTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];
      if (allowedTypes.includes(file.type)) {
        setSelectedFile(event.target.files[0]);
      } else {
        setSelectedFile(null);
        setClearFilePath('clear');
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Please select a valid Excel file (.xls or .xlsx).',
            severity: 'error'
          })
        );
      }
    }
  };

  const handleSubmit = (event) => {
    dispatch(AppActions.toggleSnackBarClose());

    event.preventDefault();
    const formData = new FormData();
    formData.append('File', selectedFile);

    addCompanyLeaveBulk(formData)
      .then((res) => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Holiday Uploaded Successfully',
            severity: 'success'
          })
        );
        setSelectedFile(null);
        setClearFilePath('clear after success');
        setIsGetDataChild(!isGetDataChild);
      })
      .catch(() => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Unable to Upload Holiday',
            severity: 'error'
          })
        );
      });
  };

  return (
    <>
      <Helmet>
        <title>Employee Management</title>
      </Helmet>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            sx={{ pl: 3, pt: 2 }}
            style={{
              marginLeft: '0px',
              marginTop: '7px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Year Plan
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
        <Grid item>
          <form onSubmit={handleSubmit}>
            <Button sx={{ mt: 2, mr: 3 }} variant="outlined">
              <input
                key={clearFilePath}
                accept=".xlsx, .xls" 
                type="file" 
                onChange={handleFileSelect} />
            </Button>
            <Button
                id="btn-bankInfoDownload"
                sx={{
                  mt: 2, mr: 3,
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                type='button'
                variant="outlined"
                startIcon={<GetAppIcon fontSize="small" />}
                href={
                  process.env.PUBLIC_URL +
                  '/templates/Holidays.xlsx'
                }
                download="Holidays"
              >
                Download Template
            </Button>
            <Button
              disabled={!selectedFile}
              sx={{
                mt: { xs: 2, md: 2 },
                mr: 3,
                fontSize: '11px',
                fontWeight: 'normal',
                width: '9rem',
                border: (!selectedFile) && '1px solid black'
              }}
              variant="contained"
              startIcon={<UploadIcon fontSize="small" />}
              type="submit"
            >
              Upload
            </Button>
          </form>
        </Grid>
      </Grid>
      <Grid
        maxWidth="lg"
        sx={{
          mx: window.innerWidth <= 990 ? 0 : 3,
          my: window.innerWidth <= 990 ? 0 : 3
        }}
        style={{
          display: 'flex',
          backgroundColor: 'white',
          maxHeight: window.innerHeight
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={0}
        >
          <Grid item xs={11} md={9} sx={{ my: 5 }}>
            <Calander isGetDataChild={isGetDataChild} />
          </Grid>
          <Grid
            item
            xs={11}
            md={9}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              mb: 5
            }}
          >
            <NavigationIcon sx={{ fontSize:'15px', color: '#00B26A', marginRight: '5px'}} />
            <div
              style={{
                marginRight: '1rem',
                color: '#00B26A',
                backgroundColor: '#E1EFE9',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Company Holiday
            </div>
            <Grid3x3Icon sx={{ fontSize:'15px' , color: '#F1C40F', marginRight: '5px'}} />
            <div
              style={{
                marginRight: '1rem',
                color: '#F1C40F',
                backgroundColor: '#FEF9E7',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Public Holiday
            </div>
            <StarIcon sx={{ fontSize:'15px', color: '#ED1C24', marginRight: '5px'}} />
            <div
              style={{
                marginRight: '1rem',
                color: '#ED1C24',
                backgroundColor: '#F8F2F2',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Mercantile Holiday
            </div>
            <Brightness1Icon sx={{ fontSize:'15px', color: '#0069E4', marginRight: '5px'}} />
            <div
              style={{
                color: '#0069E4',
                backgroundColor: '#DCE7F2',
                fontSize: '9px',
                padding: '7px',
                fontWeight: 'bold',
                borderRadius: '6px'
              }}
            >
              Bank Holiday
            </div>
          </Grid>
        </Grid>
        <SnackBar />
      </Grid>
    </>
  );
};

export default YearPlan;
